import { useNavigate } from "react-router-dom";
import { 
  Box, 
  Typography, 
  IconButton, 
  Toolbar, 
  Divider,
  Tooltip
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

// On définit l'interface avec TOUTES les propriétés attendues par tes pages
interface NavTabProps {
  text: string;
  project?: any;
  hosting?: any;
  matrice?: boolean;
  setLotId?: (id: string) => void;
  lotId?: string;
  showDialog?: boolean;
  displayReturn?: boolean;
  setOpenModal?: (open: boolean) => void; // Ajouté pour corriger l'erreur
  token?: string;
  setError?: any;
}

export default function NavTab({
  text,
  project,
  hosting,
  matrice,
  setLotId,
  lotId,
  showDialog,
  displayReturn = false,
  setOpenModal, // On le récupère ici même si on ne l'utilise pas visuellement
}: NavTabProps) {
  let navigate = useNavigate();

  const handleBack = () => {
    if (lotId && setLotId) {
      setLotId("");
    } else if (project) {
      navigate("/projets/");
    } else if (hosting) {
      navigate("/hebergement/");
    }else if (matrice) { 
      navigate("/matrices/");
    } else {
      // Optionnel : un retour par défaut si rien n'est spécifié
      navigate(-1); 
    }
  };

  return (
    <Box sx={{ width: "100%", mb: 3 }}>
      <Toolbar 
        disableGutters 
        sx={{ 
          display: "flex", 
          alignItems: "center", 
          px: { xs: 2, md: 3 },
          minHeight: "70px !important",
          bgcolor: "transparent"
        }}
      >
        {displayReturn && (
          <Tooltip title="Retour">
            <IconButton
              onClick={handleBack}
              sx={{
                mr: 2,
                color: "#64748b",
                bgcolor: "white",
                border: "1px solid #e2e8f0",
                borderRadius: "12px",
                transition: "0.2s",
                "&:hover": {
                  bgcolor: "#f1f5f9",
                  color: "#1e293b",
                  transform: "translateX(-3px)"
                }
              }}
            >
              <ArrowBackIosNewIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        )}

        <Box sx={{ flexGrow: 1 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 800,
              color: "#1e293b",
              letterSpacing: "-0.5px",
            }}
          >
            {text}
          </Typography>
        </Box>

        {/* Espace pour d'éventuels boutons à droite */}
        <Box sx={{ display: "flex", gap: 1 }}>
           {/* Si tu as besoin d'un bouton d'action global par page, tu peux l'ajouter ici */}
        </Box>
      </Toolbar>
    </Box>
  );
}